import { render, staticRenderFns } from "./_AssetCollection.vue?vue&type=template&id=5e5ea583"
import script from "./_AssetCollection.vue?vue&type=script&lang=ts"
export * from "./_AssetCollection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports